
import Vue from 'vue';

export default {
    methods: {
        errorNotify(res) {
          if(res.status == 302) {
            this.notifyVue("既に登録されています", "warning")
          } else if(res.status == 409) {
            this.notifyVue(res?.data || "サーバーエラーです。管理者に連絡してください", "error")
          } else if(res.status == 422) {
            if (res.data && res.data.errors) {
              this.notifyVue(`${res.data.errors}`, "error")
            } else {
              this.notifyVue("入力に不備があります", "error")
            }
          } else if(res.status == 500) {
            this.notifyVue("サーバーエラーです。管理者に連絡してください", "error")
          } else {
            this.notifyVue("サーバーエラーです。管理者に連絡してください", "error")
          }
        },
        notifyVue(messe, type) {
            Vue.$toast.open({
                message: messe,
                type: type,
                position: 'top-right'
            });
        },
    }
}
